/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  window.addEventListener('pageshow', function (event) {
    const navigation = performance.getEntriesByType('navigation')[0];

    const isBackForward =
      event.persisted ||
      navigation?.type === 'back_forward';

    if (isBackForward) {
      window.location.reload();
    }
  });


  document.querySelectorAll('#send-a-hint').forEach(function(button) {
    button.addEventListener('click', function() {
      const hintLink = document.querySelector('#dropahintInfoLink');
      if (hintLink) {
      console.log('Send a hint button clicked');
        hintLink.click();
      }
    });
  });

  //if .wishlist-trigger is clicked, trigger click on #dropahintInfoLink
  document.querySelectorAll('.wishlist-trigger').forEach(function(button) {
    button.addEventListener('click', function() {
      const hintLink = document.querySelector('.header__desktop__button .c-wishlist');
      if (hintLink) {
        hintLink.click();
      }
    });
  });

  // Size Guide Drawer Handler
  // Using event delegation since #size-guide is dynamically added
  const sizeGuideDrawer = document.getElementById('size-guide-drawer');
  const sizeGuideCloseBtn = document.getElementById('size-guide-drawer-close');
  const sizeGuideHasData = sizeGuideDrawer && sizeGuideDrawer.dataset.hasSizeGuide === 'true';
  const sizeGuideTrigger = document.getElementById('size-guide');
  let sizeGuideIsOpen = false;

  if (!sizeGuideHasData && sizeGuideTrigger) {
    const sizeGuideRow = sizeGuideTrigger.closest('.product__block.block__icon__row');
    if (sizeGuideRow) {
      sizeGuideRow.classList.add('hidden');
      const divider = sizeGuideRow.previousElementSibling;
      if (divider && divider.classList.contains('product__block--divider')) {
        divider.classList.add('hidden');
      }
    }
  }

  // Open drawer when #size-guide is clicked
  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'size-guide') {
      e.preventDefault();
      if (sizeGuideDrawer && sizeGuideHasData) {
        sizeGuideDrawer.removeAttribute('inert');
        sizeGuideDrawer.removeAttribute('aria-hidden');
        if (typeof sizeGuideDrawer.showModal === 'function') {
          sizeGuideDrawer.showModal();
        } else {
          sizeGuideDrawer.setAttribute('open', '');
        }
        sizeGuideIsOpen = true;
        
        // Lock body scroll
        document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      }
    }
  });

  // Close drawer
  function closeSizeGuideDrawer() {
    if (!sizeGuideDrawer || !sizeGuideIsOpen) return;
    
    sizeGuideDrawer.setAttribute('closing', '');
    
    setTimeout(() => {
      if (typeof sizeGuideDrawer.close === 'function') {
        sizeGuideDrawer.close();
      } else {
        sizeGuideDrawer.removeAttribute('open');
      }
      sizeGuideDrawer.removeAttribute('closing');
      sizeGuideDrawer.setAttribute('inert', '');
      sizeGuideDrawer.setAttribute('aria-hidden', 'true');
      sizeGuideIsOpen = false;
      
      // Unlock body scroll
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }, 300);
  }

  // Close button handler
  if (sizeGuideCloseBtn) {
    sizeGuideCloseBtn.addEventListener('click', closeSizeGuideDrawer);
  }

  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sizeGuideDrawer && sizeGuideDrawer.hasAttribute('open')) {
      closeSizeGuideDrawer();
    }
  });

  // Close on backdrop click
  if (sizeGuideDrawer) {
    sizeGuideDrawer.addEventListener('click', function(e) {
      if (e.target === sizeGuideDrawer) {
        closeSizeGuideDrawer();
      }
    });
  }

  document.addEventListener('click', function (e) {
    const li = e.target.closest('.swym-wishlist-grid > li');

    if (!li) return;

    // Let native links/buttons handle themselves
    if (e.target.closest('a, button')) return;

    const link = li.querySelector('.swym-wishlist-image-wrapper');

    if (link && link.href) {
        window.location.href = link.href;
    }
});

  const pinterestIcon = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-pinterest" viewBox="0 0 24 24"><path d="M8 14.5c-3-4.5 1.462-8 4.5-8 3.038 0 5.5 1.654 5.5 5.5 0 3.038-2 5-4 5s-3-2-2.5-5m.5-2L9 21.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const pinterestLabel = 'Pin on Pinterest';

  function getAbsoluteUrl(url) {
    try {
      return new URL(url, window.location.href).href;
    } catch (error) {
      return url;
    }
  }

  function getPinterestImageUrl(image) {
    return getAbsoluteUrl(image.currentSrc || image.src || image.getAttribute('src') || '');
  }

  function getPinterestUrl(pageUrl, mediaUrl, description) {
    const params = new URLSearchParams({
      url: pageUrl,
      media: mediaUrl,
      description: description
    });

    return `https://www.pinterest.com/pin/create/button/?${params.toString()}`;
  }

  function buildPinterestButton(image) {
    const button = document.createElement('a');
    button.className = 'pinterest-pin-button';
    button.href = getPinterestUrl(window.location.href, getPinterestImageUrl(image), image.alt || document.title);
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
    button.setAttribute('aria-label', pinterestLabel);
    button.innerHTML = `${pinterestIcon}<span class="visually-hidden">${pinterestLabel}</span>`;
    button._pinterestImage = image;

    return button;
  }

  function getPinterestContainer(image) {
    const existingContainer = image.closest('.pinterest-pin-media');

    if (existingContainer) {
      return existingContainer;
    }

    const themeImageContainer = image.closest('.image-wrapper, .image__fill, .article__author__image');

    if (themeImageContainer && themeImageContainer.closest('.article-single')) {
      themeImageContainer.classList.add('pinterest-pin-media');
      return themeImageContainer;
    }

    const link = image.closest('a');
    const picture = image.closest('picture');
    const nodeToWrap = link && link.closest('.article-single') ? link : picture || image;
    const wrapper = document.createElement('span');
    wrapper.className = 'pinterest-pin-media pinterest-pin-media--wrapped';

    nodeToWrap.parentNode.insertBefore(wrapper, nodeToWrap);
    wrapper.appendChild(nodeToWrap);

    return wrapper;
  }

  function initArticlePinterestPins(root) {
    root.querySelectorAll('.article-single img').forEach(function(image) {
      if (image.closest('.pinterest-pin-button')) return;

      const container = getPinterestContainer(image);

      if (!container) return;

      const hasButton = Array.prototype.some.call(container.children, function(child) {
        return child.classList.contains('pinterest-pin-button');
      });

      if (hasButton) return;

      container.appendChild(buildPinterestButton(image));
    });
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest('.pinterest-pin-button');

    if (!button) return;

    if (button._pinterestImage) {
      button.href = getPinterestUrl(
        window.location.href,
        getPinterestImageUrl(button._pinterestImage),
        button._pinterestImage.alt || document.title
      );
    }

    event.stopPropagation();
  }, true);

  document.addEventListener('keyup', function(event) {
    if (event.target.closest('.pinterest-pin-button')) {
      event.stopPropagation();
    }
  }, true);

  initArticlePinterestPins(document);
  document.addEventListener('shopify:section:load', function(event) {
    initArticlePinterestPins(event.target);
  });

})();
